class Toggle {
    constructor(element) {
        this.element = element;

        this.setContent();
        this.setClose();
        this.addHandler();
    }

    setContent() {
        let el = this.element.nextElementSibling;
        if(el.classList.contains('toggle-content')) {
            this.content = el;
        }
        else  {
            this.content = null;
        }
    }

    setClose() {
        let el = this.element.nextElementSibling.nextElementSibling;
        if(el.classList.contains('toggle-close')) {
            this.close = el;
        }
        else  {
            this.close = null;
        }
    }

    addHandler() {
        this.element.addEventListener('click', (e) => {
            e.preventDefault();
            this.element.classList.toggle('open');
            this.content.classList.toggle('open');
            this.close.classList.toggle('open');
        });

        if(this.close) {
            this.close.addEventListener('click', (e) => {
                e.preventDefault();
                this.element.classList.remove('open');
                this.content.classList.remove('open');
                this.close.classList.remove('open');
            })
        }

    }
}